import * as Yup from "yup";

const UPGRADE_SUB_VALIDATION = Yup.object({
  planId: Yup.string().required().label("Plan"),
  interval: Yup.string().required().label("Interval"),
  reason: Yup.string().label("Reason"),
});

export { UPGRADE_SUB_VALIDATION };
